import { Column } from '~components/table-view';

export const columns: Column[] = [
  {
    id: 'client_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'reconciliations_count',
    header: 'Reconciliations',
    type: 'text',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
  {
    id: 'reconciliation_items_count',
    header: 'Reconciliation Items',
    type: 'text',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
  {
    id: 'sum_claimed',
    header: 'Sum Claimed',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
  {
    id: 'sum_government_contribution',
    header: 'Sum of Govt Contributions',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
  {
    id: 'sum_co_contribution',
    header: 'Sum of Co-Contributions',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
  {
    id: 'sum_total',
    header: 'Sum Paid',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
];
